import { SoftwareLabel } from './software-label';

export class SoftwareArtifactReleaseType extends SoftwareLabel {}
